export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf02-de.68265fec.png";